import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Apps from "../pages/apps/page";
import AppDetail from "../pages/app-detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/apps",
    element: <Apps />,
  },
  {
    path: "/app-detail",
    element: <AppDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
